"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_dom_1 = __importDefault(require("react-dom"));

var ConditionalColorComponent_1 = __importDefault(require("../components/conditionalColor/ConditionalColorComponent"));

var ConditionalColor =
/** @class */
function () {
  function ConditionalColor(options) {
    if (options === void 0) {
      options = {};
    }

    this.el = options.el;
    this.uiContext = options.uiContext;
    this.conditionalFormatsModel = options.uiContext.getConditionalFormatsModel();
    this.uiContext.registerUIConditionalColor(this);
    this.containerEl = null;
  }

  ConditionalColor.prototype.render = function () {
    var _this = this;

    return this.uiContext.paletteServiceIsReady().then(function () {
      react_dom_1.default.render(react_1.default.createElement(ConditionalColorComponent_1.default, {
        uiContext: _this.uiContext,
        conditionalFormatsModel: _this.conditionalFormatsModel
      }), _this._createContainer());
    });
  };

  ConditionalColor.prototype.remove = function () {
    if (this.containerEl) {
      $(this.containerEl).hide();
      react_dom_1.default.unmountComponentAtNode(this.containerEl);
      this.containerEl = null;
    }
  };

  ConditionalColor.prototype._createContainer = function () {
    this.containerEl = document.createElement('div');
    this.containerEl.className = 'propertyRow property_conditionalColor';
    this.el.appendChild(this.containerEl);
    return this.containerEl;
  };

  return ConditionalColor;
}();

exports.default = ConditionalColor;
